import { render, staticRenderFns } from "./TabalSimsSelected.vue?vue&type=template&id=8884f2ba&"
import script from "./TabalSimsSelected.vue?vue&type=script&lang=ts&"
export * from "./TabalSimsSelected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports